import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import auth from '@/store/modules/auth'
import user from '@/store/modules/user'
import sections from '@/store/modules/sections'
import topics from '@/store/modules/topics'
import exercises from '@/store/modules/exercises'
import ui from '@/store/modules/ui'
import locale from '@/store/modules/locale'
import payments from '@/store/modules/payments'
import pricing from '@/store/modules/pricing'

export default new Vuex.Store({
  modules: {
    auth,
    user,
    sections,
    topics,
    exercises,
    ui,
    locale,
    payments,
    pricing
  }
})
